<template>
  <div class="effingo-cards-container">
    <div
        v-for="(card, index) in cardsData"
        :key="index"
        class="effingo-card"
        :class="getCardClass(index)"
        @mousemove="handleMouseMove"
    >
      <!-- Text Section -->
      <div class="effingo-card-content">
        <h3 class="effingo-card-title">{{ card.title }}</h3>
        <p v-if="card.subtitle" class="effingo-card-subtitle">
          {{ card.subtitle }}
        </p>
        <p class="effingo-card-description">{{ card.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleMouseMove(e) {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      e.currentTarget.style.setProperty('--mouse-x', `${x}px`);
      e.currentTarget.style.setProperty('--mouse-y', `${y}px`);
    },
    getCardClass(index) {
      return `card-${index + 1}`;
    }
  },
  data: () => ({
    cardsData: [
      {
        "title": "Revolutionizing 3D Scanning",
        "subtitle": "Instant and Accurate Digital Avatars",
        "description": "Create realistic, cost-effective 3D avatars instantly, ideal for gaming, fashion, and metaverse experiences.",
      },
      {
        "title": "Advanced Avatar Creation",
        "subtitle": "Automatic Rigging for Animation",
        "description": "Rigged avatars ready for animation, significantly cutting down development time and costs.",
      },
      {
        "title": "Optimized Performance",
        "subtitle": "Real-time Mobile and Web Applications",
        "description": "Optimized avatars ensure smooth real-time performance on both mobile and web platforms.",
      },
      {
        "title": "High-Fidelity Textures",
        "subtitle": "Realistic Visual Representation",
        "description": "High-resolution textures capture realistic skin and body details for lifelike avatars.",
      },
      {
        "title": "Cross-Platform Compatibility",
        "subtitle": "Integrate Effortlessly with Leading Software",
        "description": "Seamless integration with popular tools like Unity, Unreal Engine, and Blender for easy adoption.",
      },
    ],

  }),
};
</script>

<style scoped lang="scss">
/* Container for all cards */
.effingo-cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  //margin: 2rem auto;
  justify-content: center;
  //padding: 2rem 0 4rem;
  //padding: 1.3rem 1.3rem 4rem;
}

/* Each card */
.effingo-card {
  background-color: rgba(168, 168, 168, 0.2);
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
  min-height: 150px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  overflow: hidden;
}

/* Scale and shadow on hover */
.effingo-card:hover {
  transform: scale(1.02);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
}

/* Pseudo-element for the hover radial gradient */
.effingo-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  pointer-events: none;
  background: radial-gradient(
      800px circle at var(--mouse-x, 50%) var(--mouse-y, 50%),
      rgba(255, 255, 255, 0.06),
      transparent 40%
  );
  opacity: 0;
  transition: opacity 0.5s;
  z-index: 2;
}

/* Reveal the gradient on hover */
.effingo-card:hover::before {
  opacity: 1;
}

/* Card Content */
.effingo-card-content {
  color: #f8f8f8;
  position: relative;
  z-index: 3;
}

/* Title */
.effingo-card-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
}

/* Subtitle */
.effingo-card-subtitle {
  font-size: 1rem;
  color: #999;
  margin-bottom: 0.5rem;
}

/* Description */
.effingo-card-description {
  font-size: 1rem;
  line-height: 1.5;
}

/* Layout based on the provided image */
.card-1 {
  flex-basis: 100%;
}
.card-2, .card-3, .card-4, .card-5 {
  flex-basis: 48%;
}

/* Tablet */
@media (max-width: 768px) {
  .effingo-cards-container {
    grid-template-columns: 1fr;
  }
}
</style>
